import * as React from "react";
import { Grid, Modal, Typography, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { ContainedButton, DefaultButton } from "src/common/components";

const useStyles = makeStyles((theme: any) => ({
  btnContainer: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    alignItems: "center"
  },
  messageContainer: {
    display: "flex",
    flexDirection: "column" as "column",
    flexGrow: 1,
    justifyContent: "center" as "center",
    width: "100%",
    marginBottom: "40px"
  },
  modal: {
    [theme.breakpoints.up("sm")]: {
      minHeight: 223,
      width: 432
    },
    backgroundColor: "#fff",
    borderRadius: 6,
    boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.16), 0 2px 5px 0 rgba(0, 0, 0, 0.26)",
    display: "flex",
    flexDirection: "column" as "column",
    left: "50%",
    maxWidth: "100%",
    minHeight: 190,
    outline: "none",
    padding: "32px 24px",
    position: "absolute" as "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: 272
  },
  title: {
    marginBottom: "16px"
  }
}));

interface IOwnProps {
  openModal: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  message: string;
  confirmActionText?: string;
  title?: string;
  disableConfirmButton?: boolean;
  showCancelButton?: boolean;
}

const ModalBox = ({
  openModal,
  onCancel,
  onConfirm,
  message,
  title,
  confirmActionText = "feedback.commonComponents.buttons.confirm",
  disableConfirmButton = false,
  showCancelButton = true
}: IOwnProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Modal open={openModal} onClose={onCancel}>
      <Grid container className={classes.modal}>
        <Grid item className={classes.messageContainer}>
          {title && (
            <Typography className={classes.title} variant="h3">
              {title}
            </Typography>
          )}
          <Typography variant="body1">{message}</Typography>
        </Grid>
        <Grid item className={classes.btnContainer}>
          {showCancelButton && (
            <DefaultButton onClick={onCancel} dataTestId="cancel-button">
              {t("feedback.commonComponents.buttons.cancel")}
            </DefaultButton>
          )}{" "}
          <ContainedButton disabled={disableConfirmButton} onClick={onConfirm} dataTestId="confirm-button">
            {t(confirmActionText)}
          </ContainedButton>
        </Grid>
      </Grid>
    </Modal>
  );
};

export const ConfirmationModal = React.memo(ModalBox);
